(() => {
  const initialisePlayer = (root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const toggle = root.querySelector('[data-mbs-music-toggle]');
    const close = root.querySelector('[data-mbs-music-close]');
    const panel = root.querySelector('[data-mbs-music-panel]');
    const frame = root.querySelector('[data-mbs-music-frame]');
    const label = root.querySelector('[data-mbs-music-label]');
    const videoId = root.dataset.videoId;
    const closedLabel = root.dataset.closedLabel || 'Luister mee';
    const openLabel = root.dataset.openLabel || 'Muziek stoppen';

    if (!toggle || !panel || !frame || !videoId) return;

    const stop = () => {
      panel.hidden = true;
      frame.replaceChildren();
      toggle.setAttribute('aria-expanded', 'false');
      root.classList.remove('is-playing');
      if (label) label.textContent = closedLabel;
    };

    const play = () => {
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0&playsinline=1`;
      iframe.title = 'Mama Blijft Sterk van xDylanP';
      iframe.loading = 'lazy';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;

      frame.replaceChildren(iframe);
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      root.classList.add('is-playing');
      if (label) label.textContent = openLabel;
    };

    toggle.addEventListener('click', () => {
      if (panel.hidden) play();
      else stop();
    });

    close?.addEventListener('click', stop);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) {
        stop();
        toggle.focus();
      }
    });
  };

  const initialiseAll = () => {
    document.querySelectorAll('[data-mbs-music-player]').forEach(initialisePlayer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', initialiseAll);
})();
